import { render, staticRenderFns } from "./PoiMiniCard.vue?vue&type=template&id=7b881343&"
import script from "./PoiMiniCard.vue?vue&type=script&lang=ts&"
export * from "./PoiMiniCard.vue?vue&type=script&lang=ts&"
import style0 from "./PoiMiniCard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports